import type { ReactNode } from 'react';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 29 Oct 2026 · one field of a line item's *Szerkesztés* panel.             │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The label above, its controls under it — the panel is 440px at most and a phone's width at
 * least, and a label column beside the controls would leave the pickers a sliver at either end.
 * The layout the product owner chose on the *Line item tasks layouts* canvas (option A).
 */
export function PanelField({
  label,
  children,
}: {
  /** Already translated — a word, or a sentence with a control in it. */
  readonly label: ReactNode;
  readonly children?: ReactNode;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-1.5">
      <div className="text-muted-foreground flex flex-wrap items-center gap-1.5 text-[12px]">
        {label}
      </div>
      {children}
    </div>
  );
}
